import * as React from 'react';
import { Routes } from '../Routing';
import { NoSelectionIndicator, StateContext } from '../services/LabSimService';
import ResourceHelper, { Guid, LatestResourceType } from '../helpers/ResourceHelper';
import ConfirmAssignmentRowControl from '../controls/ConfirmAssignmentRowControl';
import PageFooter from '../partials/PageFooter';
import IntermediateCheckbox, { IntermediateCheckboxState } from '../controls/IntermediateCheckbox';
import { T } from '@testout/labsim-ui-atomics';
import styles from './CourseResourceConfirm.module.less';
import { decodeUnicodeEscapes } from '../helpers/TextHelper';
import { ResourceType } from '../helpers/ResourceHelper';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => (React.createElement(CourseResourceConfirm, Object.assign({}, props, { context: stateContext }))))));
class CourseResourceConfirm extends React.Component {
    constructor(props) {
        super(props);
        this.handleCanvasDataLoaded = () => {
            const TOModule = this.props.context.canvasModules.find((m) => m.name === 'CompTIA Content');
            const TOModuleIdOrNone = TOModule ? TOModule.id : NoSelectionIndicator;
            this.state.routeState.selectedResources.forEach((res) => {
                if (res.sectionNumber === LatestResourceType)
                    return;
                res.isGradable =
                    (res.children == null || res.children.length === 0) && res.type !== ResourceType.MODULE;
                if (res.isGradable) {
                    res.addGradeColumn = true; // default all on
                }
                if (res.isGradable && this.props.context.canvasAssignmentGroups.length > 0) {
                    res.assignmentGroup = this.props.context.canvasAssignmentGroups[0].id;
                    res.canvasAssignmentGroup = this.props.context.canvasAssignmentGroups[0];
                    res.moduleGroup = ''; // default is '' for None
                }
                else if (this.props.context.canvasModules.length > 0) {
                    res.assignmentGroup = NoSelectionIndicator;
                    res.moduleGroup = TOModuleIdOrNone; // default section headings to TO module if available
                    res.canvasModuleGroup = TOModule;
                }
            });
            this.setState({
                testOutModule: TOModule,
                testOutModuleId: TOModuleIdOrNone,
            });
        };
        this.onPublishChange = (value) => {
            this.setState({ publish: !this.state.publish });
        };
        this.onContinue = () => {
            this.props.history.push(Routes.CREATE_ASSIGNMENTS, {
                product: this.state.routeState.product,
                publish: this.state.publish,
                selectedResources: this.state.routeState.selectedResources,
            });
        };
        this.goBack = () => {
            this.props.history.replace(`${Routes.SELECT}?isbn=${this.props.location.state.isbn}`, {
                product: this.props.location.state.product,
                selectedResources: this.props.location.state.selectedResources,
                productVersionId: this.props.location.state.productVersionId,
            });
        };
        this.onAddGradeColumnChange = (resource, value) => {
            this.state.routeState.selectedResources.forEach((sec) => {
                if (sec.resourceGuid === resource.resourceGuid) {
                    this.updateGradeColumnResourceState(sec, value);
                }
            });
            const allChecked = this.state.routeState.selectedResources
                .filter((sec) => sec.isGradable)
                .every((sec) => sec.addGradeColumn);
            const allNotChecked = this.state.routeState.selectedResources
                .filter((sec) => sec.isGradable)
                .every((sec) => !sec.addGradeColumn);
            let newIndeterminateState = IntermediateCheckboxState.PARTIAL;
            if (allChecked)
                newIndeterminateState = IntermediateCheckboxState.CHECKED;
            if (allNotChecked)
                newIndeterminateState = IntermediateCheckboxState.UNCHECKED;
            this.setState({
                createGraded: !allNotChecked,
                gradeAllCheckboxState: newIndeterminateState,
            });
        };
        this.updateGradeColumnResourceState = (resource, selected) => {
            if (!resource.isGradable)
                return;
            resource.addGradeColumn = selected;
            // if they have None selected for module group, set it to TO by default
            if (!selected && resource.moduleGroup === '') {
                resource.moduleGroup = this.state.testOutModuleId;
                resource.canvasModuleGroup = this.state.testOutModule;
            }
        };
        this.onAssignmentGroupChange = (resource, e) => {
            this.state.routeState.selectedResources.forEach((sec) => {
                if (sec.resourceGuid === resource.resourceGuid) {
                    sec.assignmentGroup = e.id;
                    sec.canvasAssignmentGroup = e;
                }
            });
            this.setState({});
        };
        this.onModuleGroupChange = (resource, e) => {
            this.state.routeState.selectedResources.forEach((sec) => {
                if (sec.resourceGuid === resource.resourceGuid) {
                    sec.moduleGroup = e ? e.id : '';
                    sec.canvasModuleGroup = e;
                }
            });
            this.setState({});
        };
        this.onSetAllAssignmentGroupsChange = (e) => {
            this.state.routeState.selectedResources.forEach((sec) => {
                sec.assignmentGroup = e.id;
                sec.canvasAssignmentGroup = e;
            });
            this.setState({});
        };
        this.onSetAllModuleGroupsChange = (e) => {
            this.state.routeState.selectedResources.forEach((sec) => {
                // we don't want to set module None when add gradebook column is NOT checked
                if (!sec.addGradeColumn && e === undefined)
                    return;
                sec.moduleGroup = e ? e.id : '';
                sec.canvasModuleGroup = e;
            });
            this.setState({});
        };
        this.onSetAllGradeChange = (checkboxState) => {
            const selected = checkboxState === IntermediateCheckboxState.CHECKED;
            this.state.routeState.selectedResources.forEach((sec) => {
                this.updateGradeColumnResourceState(sec, selected);
            });
            const newCheckboxState = selected
                ? IntermediateCheckboxState.CHECKED
                : IntermediateCheckboxState.UNCHECKED;
            this.setState({ gradeAllCheckboxState: newCheckboxState });
        };
        const selectedResources = props.location.state.selectedResources;
        const currentProduct = props.location.state.product;
        if (!currentProduct || !selectedResources) {
            alert('Invalid route state');
            this.props.history.push(Routes.BROWSE);
        }
        this.state = {
            createGraded: true,
            publish: true,
            routeState: props.location.state,
            testOutModuleId: NoSelectionIndicator,
            gradeAllCheckboxState: IntermediateCheckboxState.CHECKED,
        };
        props.context.onCanvasDataLoaded().then(this.handleCanvasDataLoaded);
    }
    renderResources() {
        const rowControls = this.state.routeState.selectedResources
            .filter((s) => s.sectionNumber !== LatestResourceType)
            .sort(ResourceHelper.sortSectionNumbers)
            .map((resource) => {
            return (React.createElement(ConfirmAssignmentRowControl, { key: resource.resourceGuid !== Guid.EMPTY
                    ? resource.resourceGuid
                    : resource.sectionNumber, resource: resource, onAddGradeColumnChange: this.onAddGradeColumnChange, onAssignmentGroupChange: this.onAssignmentGroupChange, onModuleGroupChange: this.onModuleGroupChange }));
        });
        const latest = this.state.routeState.selectedResources.find((s) => s.sectionNumber === LatestResourceType);
        if (latest) {
            const latestResource = (React.createElement(ConfirmAssignmentRowControl, { key: latest.resourceGuid !== Guid.EMPTY ? latest.resourceGuid : latest.sectionNumber, resource: latest, onAddGradeColumnChange: this.onAddGradeColumnChange, onAssignmentGroupChange: this.onAssignmentGroupChange, onModuleGroupChange: this.onModuleGroupChange }));
            rowControls.unshift(latestResource);
        }
        return rowControls;
    }
    render() {
        return (React.createElement(StateContext.Consumer, null, (stateContext) => {
            var _a, _b, _c, _d;
            const isLTIAdvantage = stateContext.isIntegrationLTIAdvantage();
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.header },
                    React.createElement(T.Text.H1, { className: styles.title, automationId: 'title', variation: T.Text.Variation.H1_Large }, "Confirm Resource Grading"),
                    React.createElement("div", { className: styles.prodTitle },
                        React.createElement(T.Text.H2, { automationId: 'prodTitle', className: styles.versionInfo },
                            React.createElement("div", { className: styles.productLabel },
                                decodeUnicodeEscapes(((_a = this.props.location.state.product) === null || _a === void 0 ? void 0 : _a.title) || ''),
                                ' ',
                                "(", (_b = this.props.location.state.product) === null || _b === void 0 ? void 0 :
                                _b.isbn,
                                ")"),
                            React.createElement("div", null,
                                `\t${((_c = this.props.location.state.product) === null || _c === void 0 ? void 0 : _c.language) || ''}`,
                                ` ${((_d = this.props.location.state.product) === null || _d === void 0 ? void 0 : _d.version) || ''}`)))),
                React.createElement(T.InfoBox, { automationId: 'infoBox', className: styles.infobox },
                    React.createElement(T.InfoBox.Body, { iconVariation: T.IconVariation.InfoCircle }, "The following resources will be used to create assignments in the course. For resources that shouldn't be graded, remove the checkmark next to it.")),
                stateContext.isFamilyCanvas() && stateContext.canvasDataLoaded && (React.createElement("div", { className: styles.groups },
                    React.createElement("div", null,
                        React.createElement(T.Input.Label, { htmlFor: 'assignAllAssignment', automationId: 'assignmentAllLabel' }, "Assign all to assignment Group"),
                        React.createElement(T.Dropdown, { automationId: 'assignAllAssignment', id: 'assignAllAssignment' },
                            React.createElement(T.Dropdown.Toggle.Button, { variation: T.ButtonVariation.Secondary }, "Select Assignment Group"),
                            React.createElement(T.Dropdown.Menu, null, stateContext.canvasAssignmentGroups.map((e) => (React.createElement(T.Dropdown.Item.Button, { onClick: () => this.onSetAllAssignmentGroupsChange(e), automationId: e.id, key: e.id }, e.name)))))),
                    React.createElement("div", null,
                        React.createElement(T.Input.Label, { htmlFor: 'assignAllModule', automationId: 'moduleAllLabel' }, "Assign all to Module Group"),
                        React.createElement(T.Dropdown, { automationId: 'assignAllModule', id: 'assignAllModule' },
                            React.createElement(T.Dropdown.Toggle.Button, { variation: T.ButtonVariation.Secondary }, "Select Module Group"),
                            React.createElement(T.Dropdown.Menu, null,
                                React.createElement(T.Dropdown.Item.Button, { onClick: () => this.onSetAllModuleGroupsChange(), automationId: 'noneAll' }, "None"),
                                stateContext.canvasModules.map((e) => (React.createElement(T.Dropdown.Item.Button, { onClick: () => this.onSetAllModuleGroupsChange(e), automationId: e.id, key: e.id }, e.name)))))))),
                React.createElement("div", { className: styles.table, "data-automationid": 'resourcesTable' },
                    React.createElement("table", null,
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Resource"),
                                React.createElement("th", { className: 'center' }, React.createElement("div", { className: styles.checkboxHeader },
                                    React.createElement(IntermediateCheckbox, { name: 'graded', checkedState: this.state.gradeAllCheckboxState, onChange: this.onSetAllGradeChange }),
                                    "Graded")),
                                stateContext.isFamilyCanvas() && (React.createElement(React.Fragment, null,
                                    React.createElement("th", null, "Assignment Group"),
                                    React.createElement("th", null, "Module Group"))))),
                        React.createElement("tbody", null, this.renderResources()))),
                !isLTIAdvantage && (React.createElement(T.Input.Checkbox, { checked: this.state.publish, onChange: this.onPublishChange, name: 'publishCheck', automationId: 'publishCheck' }, "Publish all assignments on creation")),
                React.createElement(T.ActionToolbar, null,
                    React.createElement(T.ActionToolbar.Group, { right: true, className: styles.toolbar },
                        React.createElement(T.Button, { automationId: 'noConfirmButton', onClick: this.goBack, variation: T.ButtonVariation.Secondary }, "Back"),
                        React.createElement(T.Button, { disabled: !stateContext.canvasDataLoaded, automationId: 'confirmButton', className: styles.contBtn, onClick: this.onContinue }, "Create Links"))),
                React.createElement("div", { className: styles.footer },
                    React.createElement(PageFooter, null))));
        }));
    }
}
//# sourceMappingURL=CourseResourceConfirm.js.map